var React = require('react');

function FilterAdd (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M0,1 L16,1 L16,2.7109375 L10,8.7109375 L10,15 L6,15 L6,8.7109375 L0,2.7109375 L0,1 Z M15,2.2890625 L15,2 L1,2 L1,2.2890625 L7,8.2890625 L7,14 L9,14 L9,8.2890625 L15,2.2890625 Z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M13,12 L13,10 L14,10 L14,12 L16,12 L16,13 L14,13 L14,15 L13,15 L13,13 L11,13 L11,12 L13,12 Z","key":1})]));
}

FilterAdd.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = FilterAdd;

FilterAdd.default = FilterAdd;
